import { ICustomer } from '../customers/customer-service';
import { ApiService } from '../../utils/api-service';
import { autoinject } from 'aurelia-framework';

@autoinject
export class DataCopyService {
	constructor(private api: ApiService) {
	}

	getSourceCustomersForTargetCustomer(targetCustomerId: string): Promise<ICustomer[]> {
		return this.api.fetchJson(`customers-maps/source-customers/for-target-customer/${targetCustomerId}`);
	}
}
